export { default as Sendform } from './form';


// WEBPACK FOOTER //
// ./js/libs/sendform/sendform2.js